/* istanbul ignore next */
const createPersonalDataPayload = Object.freeze({
  firstName: null,
  lastName: null,
  maternalLastName: null,
  professionId: null,
  positionCode: null,
  workActivityId: null,
  countryCode: null,
  email: null,
  phone: null,
  address: null,
  taxDeclaration: null,
  executiveCode: null,
  idPreferredOffice: null,
  scheduling: null,
  idDeliveryType:null,
  idOfficePickup:null,
  idDeliveryType:null
});
/* istanbul ignore next */
export const genPayloadToRegisterPersonalData = (personalData) => {
  const payload = { ...createPersonalDataPayload };
  
  payload.firstName = personalData.firstName.value.replace(/  +/g, ' ').trim();
  payload.lastName = personalData.lastName.value.replace(/  +/g, ' ').trim();
  payload.maternalLastName = personalData.maternalLastName.value.replace(/  +/g, ' ').trim();
  payload.professionId = personalData.profession.value.id;
  payload.positionCode = personalData.position.value.codigo;
  payload.workActivityId = personalData.workActivity.value.id;
  payload.countryCode = personalData.countryNationality.value.codigo;
  payload.email = personalData.email.value.toLowerCase();
  payload.phone = personalData.phone.value;
  // descomentar cuando el servicio de registrar soporte la propiedad
  payload.scheduling = {
    communeId: personalData.scheduling.value.communeId,
    day: personalData.scheduling.value.day,
    hour: personalData.scheduling.value.hour,
    latitude: personalData.address.value.latitude,
    longitude: personalData.address.value.longitude,
    regionId: personalData.scheduling.value.regionId,
    moduleId:personalData.scheduling.value.moduleId
  }
  /* istanbul ignore next */       
  sessionStorage.setItem('scheduling-day', payload.scheduling.day);
  payload.address = {
    ...personalData.address.value,
    anotherData: personalData.address.anotherData,
  };
  /* istanbul ignore next */ 
  sessionStorage.setItem('direction-despacho',JSON.stringify(payload.address))
  payload.taxDeclaration = personalData.taxDeclaration.value;
  payload.executiveCode = personalData.executiveCode.value;
  payload.idPreferredOffice = personalData.preferredOffice.value.id;
  /* istanbul ignore next */
  const hasValidScheduling =
  payload.scheduling &&
  payload.scheduling.communeId &&
  payload.scheduling.day &&
  payload.scheduling.hour &&
  payload.scheduling.latitude &&
  payload.scheduling.longitude &&
  payload.scheduling.regionId;
  payload.idOfficePickup = (personalData.preferredOffice.value.id && !hasValidScheduling )? personalData.preferredOffice.value.id  : 0
  payload.idDeliveryType = hasValidScheduling ? 1 : 2;

  return payload;
};

export default createPersonalDataPayload;
